import { InquiryJson, InquiryStatus } from "../../../domain/inquiry/Inquiry";
import { InquiryDetailJson } from "../../../domain/inquiry/InquiryDetail";
import { InquiryListItemJson } from "../../../domain/inquiry/InquiryListItem";
import { ApiPaths } from "../../api/ApiPaths";
import { ApiRequest } from "../../api/ApiRequest";

export type GetInquiryListSuccessResponseType = {
    inquiries: InquiryListItemJson[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export type GetInquiryDetailSuccessResponseType = {
    inquiryDetail: InquiryDetailJson,
    error: undefined
}

export type UpdateInquirySuccessResponseType = {
    inquiry: InquiryJson,
    error: undefined
}

export type RegisterInquirySuccessResponseType = {
    inquiry: InquiryJson,
    error: undefined

}

export async function registerInquiry(careRecipientId: string | null, tel: string | null, category: string, content: string, email: string): Promise<RegisterInquirySuccessResponseType> {
    return await ApiRequest.post(
        "/api/inquiry",
        {},
        { careRecipientId: careRecipientId, tel: tel, inquiryCategory: category, content: content, email: email },
        () => {},
        () => {}
    );
}

export async function getInquiryList(): Promise<GetInquiryListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.adminInquiryList,
        {},
        () => {},
        () => {});
}

export async function getInquiry(id: string): Promise<GetInquiryDetailSuccessResponseType> {
    return await ApiRequest.get(
        `/api/admin/inquiry/${id}`,
        {},
        () => {},
        () => {});
}

export async function updateInquiry(id: string, status?: InquiryStatus, memo?: string) {
    return await ApiRequest.patch(
        `/api/admin/inquiry/${id}`,
        {},
        { status: status, memo: memo },
        () => {},
        () => {}
    );
}
